import React, { useEffect } from 'react';
import Clients from '../components/Clients';
import Footer from '../components/Footer';
import Benefits from '../components/Benefits';
import Career from '../components/Career';


const Layanan = () => {
    useEffect(() => {
        window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
        <>
            <Career />
            <Clients />
            <Benefits />
            <Footer />
        </>

    )
}

export default Layanan;

